import React from 'react';
import { Link } from 'react-router-dom';
import { getCopyrightYears } from '../utils/dateUtils';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-links">
          <Link to="/contact" className="footer-link">Contact</Link>
          <Link to="/about" className="footer-link">About</Link>
          <Link to="/privacy" className="footer-link">Privacy Policy</Link>
          <Link to="/terms" className="footer-link">Terms & Conditions</Link>
          <Link to="/disclaimer" className="footer-link">Disclaimer</Link>
          <Link to="/sitemap" className="footer-link">Sitemap</Link>
        </div>
        
        <div className="footer-info">
          <p className="disclaimer">
            We are not affiliated with YouTube, TikTok, Google, or ByteDance.
          </p>
          <p className="credits">
            Free YouTube & TikTok Video Downloader - Fast, Secure & HD Quality Downloads.
          </p>
        </div>
        
        <div className="footer-bottom">
          <p>Copyright {getCopyrightYears(2025)}</p>
          <div className="language-selector">
            <span>English</span>
            <span className="dropdown-icon">▼</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
